

import * as types from "./mutation_types"
import notify from "@/utils/notify"
import router from "@/router"
import backend from "@/utils/backend"
import { LOGIN } from "@/utils/apiUrl"
import { socket } from "@/socket"
import newConversationListener from "@/socket/actions"


export const login =  ({ commit,dispatch }, data) =>{
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)
    backend({ method: "POST", url: LOGIN, data,isAuth:false,client:true }).then(({ data }) => {
       
  
        newConversationListener(dispatch)

        commit(types.SET_ITEMS, data.user)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE, "Is Ok")
        commit(types.SET_IS_LOGIN, true)
        localStorage.setItem("token",data.access_token ??  data.token)
        router.push({name:"Inboxs"})
    }).catch((err) => {
        
        socket.disconnect()
        socket.off();

        commit(types.SET_IS_ERROR)
        commit(types.SET_IS_LOGIN, false)
        notify(err?.response?.data?.message ?? err.message ?? err)
        localStorage.clear()
        router.push({name:"AuthLogin"})

        commit(types.SET_MESSAGE, err.message ?? err)

    }).finally(() => {

        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
    })
}
export const resetData = ({ commit }) => {
    commit(types.RESET)
}



